import Vue from "vue";

let oldPartyId = '';

Vue.component("modifications-annex-item", {
    props: ["annex", "forEntity", "annexItemLabel", "noteType", "annexItem", "startdate", "enddate"],
    data() {
        return {
            entityLoading: false,
            nonEntityLoading: false,
            entities: [],
            nonEntities: [],
            isOpen: null
        };
    },
    methods: {
        search(annexId) {
            const self = this;

            if (self.forEntity) {
                self.searchEntity(annexId);
            }
            else {
                self.searchNote(annexId);
            }
        },
        searchEntity(annexId) {
            const self = this;

            self.entityLoading = true;
            self.$services.modification.searchEntityByAnnexAndPartyAndDateRange({
                searchParameterDateFrom: self.startdate,
                searchParameterDateTo: self.enddate,
                language: window.currentLanguage,
                annexId: annexId
            }).then((data) => {
                self.entities = data.entities;
                self.entityLoading = false;
            });
        },
        searchNote(annexId) {
            const self = this;

            self.nonEntityLoading = true;
            self.$services.modification.searchNoteByAnnexAndPartyAndDateRange({
                searchParameterDateFrom: self.startdate,
                searchParameterDateTo: self.enddate,
                language: window.currentLanguage,
                annexId: annexId,
                noteType: self.noteType
            }).then((data) => {
                self.nonEntities = data.notes;
                self.nonEntityLoading = false;
            });
        }
    },
    template: `        
		<div class="modification-content">                                     
            <b-collapse
		        class="modification-card mb-2"
		        animation="slide"		                    
		        :key="annexItem + '-' + annex.id"
		        :open="isOpen == annexItem + annex.id"
		        @@open="isOpen = annexItem + annex.id">
                <template #trigger="props">
                    <div class="modification-card-header" role="button" @click="search(annex.id)">
                        <p class="modification-card-header-title">
                            <span v-html="annexItemLabel"></span>
                        </p>
                    </div>                                    				        
                </template>                
                    <div class="modification-card-content">
                        <div class="modification-content" v-if="forEntity">
                            <template v-if="entityLoading"><loading></loading></template>
                            <template v-else>
                                <modifications-entity :entities="entities"></modifications-entity>
                            </template>                            
                        </div>
                        <div class="modification-content" v-else>
                            <template v-if="nonEntityLoading"><loading></loading></template>
                            <template v-else>
                                <modifications-parent :parents="nonEntities" ownerType="NOTE"></modifications-parent>
                            </template>
                        </div>
                    </div>                
            </b-collapse>                                                                                    
		</div>        
	`
});

